import { Modal } from 'antd';

import './style.less';
import SearchLabel from './SearchLabel';

function AuthorExistModal({ open, onCancel, onOk, authorInfo }) {
  return (
    <Modal
      title="Kullanıcı Detayları"
      open={open}
      okText="Evet"
      cancelText="Hayır"
      onCancel={onCancel}
      destroyOnClose
      onOk={onOk}
      centered
    >
      <div className="modal-body-wrapper">
        <SearchLabel
          committeeTagClassName="gx-mb-0"
          user={authorInfo}
        />{' '}
        isimli kullanıcıyı yazar olarak eklemek istediğinize emin misiniz?
      </div>
    </Modal>
  );
}

export default AuthorExistModal;
